export default "__VITE_ASSET__DXrPlXqX__"